import { Component, OnDestroy, OnInit } from '@angular/core';
import { control, olx } from 'openlayers';
import { MapComponent } from '../map.component';

@Component({
  selector: 'aol-control-zoomslider',
  template: `<ng-content></ng-content>`
})
export class ControlZoomSliderComponent implements OnInit, OnDestroy {
  instance: control.ZoomSlider;

  constructor(private map: MapComponent) {}

  ngOnInit() {
    this.instance = new control.ZoomSlider(this as unknown as olx.control.ZoomSliderOptions);
    this.map.instance.addControl(this.instance);
  }

  ngOnDestroy() {
    this.map.instance.removeControl(this.instance);
  }
}
